import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { useTheme } from '@mui/material/styles';
import ListSubheader from '@mui/material/ListSubheader';

type Props = {
    stepNumber: number
}

const steps = ['Key Filters', 'Refine Filters', "Name & Options", "Assign Leads"]

const ICPWizardSteps = ({ stepNumber }: Props) => {
    const theme = useTheme();

    return (
        <List
            sx={{ display: 'flex', flexDirection: 'column', width: 240, minWidth: 240, bgcolor: 'background.paper', borderRight: `1px solid ${theme.palette.divider}`, marginRight: 5 }}
            aria-label="contacts"
        >
            {steps.map((step, index) => {
                const color = index < stepNumber ? theme.palette.success.main : index == stepNumber ? theme.palette.primary.main : theme.palette.secondary.main;

                return <ListItem disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <CheckCircle sx={{ color: color }} />
                        </ListItemIcon>
                        <ListItemText primary={step} />
                    </ListItemButton>
                </ListItem>
            })}
        </List>
    );
}

export { ICPWizardSteps };
export default ICPWizardSteps;
